<div class="card card--picto-corner">
  <a class="card-header" [routerLink]="multirankUrl">
    <div class="card-picto">
      <div class="background-picto -color-{{ color }}">
        <svg-icon
          src="assets/images/svg-icons/icon-medal.svg"
          [svgStyle]="{ 'width.px': '32' }"
        ></svg-icon>
      </div>
    </div>

    <div class="card-header-content" *ngIf="examGroup">
      <div class="card-title">
        <p>{{ examGroup.title }}</p>
      </div>
      <div class="card-theme">
        <p>{{ examGroup.period }} {{ examGroup.year }}</p>
      </div>
    </div>

    <div class="card-infos" *ngIf="examGroup">
      <div class="card-info" *ngIf="languageService.isParticipationNumbersEnabled">
        <svg-icon
          class="info-icon"
          src="assets/images/svg-icons/icon-participants.svg"
          [svgStyle]="{ 'width.px': '18' }"
        ></svg-icon>
        <span class="info-txt">
          {{ examGroup.totalParticipants | number : '1.0-0' : 'fr' }}
        </span>
      </div>
    </div>
  </a>

  <div class="card-content--table" *ngIf="type == 'dashboard'">
    <div class="pt-8 grid grid-cols-[40px_1fr_140px_90px] font-bold text-13">
      <ng-container *ngIf="examGroup && !loadingStudentRankings">
        <ng-container
          *ngFor="let examGroupSession of examGroup.examGroupSessions; let index = index"
        >
          <div>{{ index + 1 }}</div>
          <div
            (click)="modalService.openModalStudentProfile(examGroupSession.student.id)"
            class="cursor-pointer text-site-main-one"
          >
            {{ examGroupSession.student.username }}
          </div>
          <div>{{ examGroupSession.university.name }}</div>
          <div>
            {{ examGroupSession.totalGrade | number : '1.0-2' : 'fr' }}
            {{ 'examens.pts' | translate }}
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="!examGroup || loadingStudentRankings">
        <div class="col-span-4 h-[350px] flex justify-center items-center">
          <app-loader-dots></app-loader-dots>
        </div>
      </ng-container>
    </div>
    <div class="p-8 flex justify-center">
      <a
        matRipple
        [matRippleCentered]="false"
        [matRippleUnbounded]="true"
        [matRippleRadius]="50"
        [routerLink]="multirankUrl"
        class="btn-nnki btn-nnki-primary btn-nnki-uppercase btn-nnki-heavy text-12 w-96"
      >
        {{ 'notifications.voir_classement' | translate }}
      </a>
    </div>
  </div>

  <div class="card-content rounded-b-card" *ngIf="type == 'ranking-list'">
    <div class="block--categories hidden sm:flex">
      <a
        class="badge-category"
        *ngFor="let exam of examGroup.exams | slice : 0 : 6; let i = index"
        [routerLink]="['/app/exams/examens/', exam.id]"
      >
        {{ exam.title }}
      </a>
      <div *ngIf="examGroup.exams.length > 6" class="badge-category">
        +{{ examGroup.exams.length - 6 }}
      </div>
    </div>
  </div>
</div>
